import React, { useRef } from "react"
import { IconButton, Box, TextField, Tooltip } from "@material-ui/core"
import { Link as LinkIcon } from "@material-ui/icons"
import Config from "react-global-configuration"
import { Trans } from "@lingui/macro"
import useSnackbar from "../SnackbarProvider/useSnackbar"
import { Icon } from "../Icon/Icon"

const CopyLinkButton = ({
  children,
  link,
  iconSize = "medium",
  tooltipClassName = "",
  iconButtonClassName = "",
  ariaLabel = "copy link button",
  message = <Trans>Link copied to your clipboard</Trans>
}) => {
  const inputRef = useRef(null)
  const { showMessage } = useSnackbar()
  const config = Config.get()
  const url = link || `${config.clientLinkBaseUri || config.clientBaseUri}${window.location.pathname}`

  const handleClick = async () => {
    inputRef.current.select()
    await navigator.clipboard.writeText(url)
    showMessage({
      message,
      icon: <Icon name="clipboard" />
    })
    inputRef.current.blur()
  }

  return (
    <>
      {children && <Box onClick={handleClick}>{children}</Box>}

      {!children && (
        <Tooltip title={<Trans>Copy link</Trans>} className={tooltipClassName}>
          <IconButton size={iconSize} onClick={handleClick} className={iconButtonClassName} aria-label={ariaLabel}>
            <LinkIcon />
          </IconButton>
        </Tooltip>
      )}

      <TextField
        inputRef={inputRef}
        value={url}
        inputProps={{ tabIndex: -1 }}
        style={{
          left: 0,
          bottom: 0,
          width: 1,
          height: 1,
          opacity: 0,
          position: "fixed"
        }}
      />
    </>
  )
}

export { CopyLinkButton }
